import { render, staticRenderFns } from "./CardBrand.vue?vue&type=template&id=4be833b6"
import script from "./CardBrand.vue?vue&type=script&lang=ts"
export * from "./CardBrand.vue?vue&type=script&lang=ts"
import style0 from "./CardBrand.vue?vue&type=style&index=0&id=4be833b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports